export default __webpack_public_path__ + "resources/icons/n111-61cb.webp";